import { Asset } from "@/model/asset/asset"

export type LicensePlateAssetLookup = ReadonlyMap<string, Asset | undefined>

export const normalizeLicensePlate = (value: string): string =>
    value.toLowerCase().replace(/[\s-]/g, "")

export const createLicensePlateAssetLookup = (
    assets: readonly Asset[]
): LicensePlateAssetLookup => {
    const lookup = new Map<string, Asset | undefined>()

    for (const asset of assets) {
        if (!asset.licensePlate) {
            continue
        }

        const normalizedLicensePlate = normalizeLicensePlate(asset.licensePlate)
        if (!normalizedLicensePlate) {
            continue
        }

        lookup.set(
            normalizedLicensePlate,
            lookup.has(normalizedLicensePlate) ? undefined : asset
        )
    }

    return lookup
}

export const resolveLicensePlateAsset = (
    lookup: LicensePlateAssetLookup,
    licensePlate: string
): Asset | undefined => lookup.get(normalizeLicensePlate(licensePlate))
